import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main className="min-h-screen flex items-center justify-center bg-gradient-to-br from-sky-50 to-white px-6">
      <div className="text-center max-w-md">
        <p className="text-xs tracking-[0.22em] uppercase font-bold text-sky-700">404</p>
        <h1 className="mt-3 font-heading text-4xl font-extrabold text-slate-900">Lost in the deep end.</h1>
        <p className="mt-3 text-slate-600">We couldn&apos;t find that page. Let&apos;s get you back to clear water.</p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-slate-900 text-white font-bold hover:bg-sky-700"
          data-testid="notfound-home"
        >
          Back to home
        </Link>
      </div>
    </main>
  );
}
